import React from 'react';
import { FileItemProps } from '../FileItem/FileItem.component';
import FolderBreadCrumbItem from './FolderBreadCrumbItem.component';
import './FolderBreadCrumbs.component.scss';

export type FolderBreadCrumbs = {
  path: string;
  files?: FileItemProps[];
  onPathClicked: (folderName: string) => void;
};

const FolderBreadCrumbs = ({
  path = '',
  files,
  onPathClicked,
}: FolderBreadCrumbs) => {
  const pathList = decodeURIComponent(path)
    .split('/')
    .map(folderPath => folderPath.replace(/%20/g, ' '));
  let currentPath = [
    {
      name: pathList[0],
      files,
    },
  ] as FileItemProps[];
  let currenPath = '';
  const onPathClick = (pathName: string) => {
    onPathClicked(pathName);
  };
  return (
    <div className="folder-bread-crumbs">
      {pathList.map((folderPath = '', index) => {
        const file =
          currentPath?.find(file => file.name === folderPath) ||
          ({} as FileItemProps);
        const isDisabled = pathList.length === index + 1;
        currentPath = file?.files;
        currenPath = `${currenPath}${index === 0 ? '' : '/'}${folderPath}`;
        return (
          <FolderBreadCrumbItem
            key={`${folderPath}-${index}`}
            file={file}
            isDisabled={isDisabled}
            path={currenPath}
            onPathClicked={onPathClick}
          />
        );
      })}
    </div>
  );
};

export default FolderBreadCrumbs;
